export default __webpack_public_path__ + "static/media/src_facebook.6ab58678.svg";